import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Listbox } from '@/components/ui/listbox';
import {
  MEMBER_TITLE_OTHER,
  memberTitleListboxOptions,
  memberTitleListboxValue,
} from '@/lib/member-title-options';

type MemberTitleFieldProps = {
  value: string;
  onChange: (next: string) => void;
  clearLabel: string;
  popoverPortal?: 'dialog';
};

export const MemberTitleField = ({
  value,
  onChange,
  clearLabel,
  popoverPortal,
}: MemberTitleFieldProps) => {
  const { t } = useTranslation('people');
  const listboxValue = memberTitleListboxValue(value);
  const showCustom = listboxValue === MEMBER_TITLE_OTHER;

  return (
    <div className="space-y-3">
      <Listbox
        value={listboxValue}
        onChange={(next) => {
          if (next === null) {
            onChange('');
            return;
          }
          if (next === MEMBER_TITLE_OTHER) {
            if (listboxValue !== MEMBER_TITLE_OTHER) onChange('');
            return;
          }
          onChange(next);
        }}
        options={memberTitleListboxOptions(t)}
        clearable
        clearLabel={clearLabel}
        popoverPortal={popoverPortal}
      />
      {showCustom ? (
        <Input
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={t('members.form.titleOtherPlaceholder')}
        />
      ) : null}
    </div>
  );
};
